import {FocusMonitor} from '@angular/cdk/a11y';
import {coerceBooleanProperty} from '@angular/cdk/coercion';
import {Component, DoCheck, ElementRef, Injector, Input, OnDestroy, OnInit, Optional, Self} from '@angular/core';
import {ControlValueAccessor, FormBuilder, NgControl} from '@angular/forms';
import {MatFormFieldControl} from '@angular/material/form-field';
import {Subject} from 'rxjs';


@Component({
  selector: 'app-dynamic-input-blur-input',
  templateUrl: './dynamic-input-blur.html',
  styleUrls: ['./dynamic-input-blur.scss'],
  providers: [{provide: MatFormFieldControl, useExisting: DynamicInputBlurComponent}],
  host: {
    '[class.example-floating]': 'shouldLabelFloat',
    '[id]': 'id',
    '[attr.aria-describedby]': 'describedBy',
  }
})
export class DynamicInputBlurComponent implements ControlValueAccessor, OnInit, DoCheck, MatFormFieldControl<any>, OnDestroy {
  static nextId = 0;
  static ngAcceptInputType_disabled: boolean | string | null | undefined;
  static ngAcceptInputType_required: boolean | string | null | undefined;
  private _placeholder: string;
  _disabled = false;
  private _required = false;
  // parts: FormGroup;
  stateChanges = new Subject<void>();
  focused = false;
  errorState = false;
  controlType = 'example-tel-input';
  id = `example-tel-input-${DynamicInputBlurComponent.nextId++}`;
  describedBy = '';
  field;

  onChange = (_: any) => {
    // tslint:disable-next-line
  };
  onTouched = () => {
    // tslint:disable-next-line
  };

  @Input()
  get placeholder(): string {
    return this._placeholder;
  }

  set placeholder(value: string) {
    this._placeholder = value;
    this.stateChanges.next();
  }

  @Input()
  get required(): boolean {
    return this._required;
  }

  set required(value: boolean) {
    this._required = coerceBooleanProperty(value);
    this.stateChanges.next();
  }

  @Input()
  get disabled(): boolean {
    return this._disabled;
  }

  set disabled(value: boolean) {
    this._disabled = coerceBooleanProperty(value);
    this._disabled = !!this._disabled;
    this.stateChanges.next();
  }

  @Input()
  get value() {
    return this.field;
  }

  set value(v) {
    this.field = v;
    this.stateChanges.next();
  }

  constructor(formBuilder: FormBuilder, private _focusMonitor: FocusMonitor, private _elementRef: ElementRef<HTMLElement>, public elRef: ElementRef, public injector: Injector, @Optional() @Self() public ngControl: NgControl) {

    // this.parts = formBuilder.group({
    //   area: [null, [Validators.required, Validators.minLength(3), Validators.maxLength(10)]],
    //   exchange: [null, [Validators.required, Validators.minLength(3), Validators.maxLength(10)]],
    //   subscriber: [null, [Validators.required, Validators.minLength(4), Validators.maxLength(10)]],
    // });

    _focusMonitor.monitor(_elementRef, true).subscribe(origin => {
      if (this.focused && !origin) {
        this.onTouched();
      }
      this.focused = !!origin;
      this.stateChanges.next();
    });

    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnInit() {
    // this.ngControl = this.injector.get(NgControl);
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnDestroy() {
    this.stateChanges.complete();
    this._focusMonitor.stopMonitoring(this._elementRef);
  }

  ngDoCheck(): void {
    if (this.ngControl) {
      this.errorState = this.ngControl.invalid && this.ngControl.touched;
      this.stateChanges.next();
    }
  }

  onBlur(v) {
    this.writeValue(v.target.value);
    this.onChange(this.field.value);
  }

  get empty() {
    if (!this.field.value) return false;
  }

  get shouldLabelFloat() {
    return this.focused || !this.empty;
  }

  setDescribedByIds(ids: string[]) {
    this.describedBy = ids.join(' ');
  }

  onContainerClick(event: MouseEvent) {
    if ((event.target as Element).tagName.toLowerCase() != 'input') {
      // tslint:disable-next-line
      this._elementRef.nativeElement.querySelector('input')!.focus();
    }
  }

  writeValue(v): void {
    this.field.value = v;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  _handleInput(): void {
    this.onChange(this.value);
  }
}
